(function($){
    var running     = false,
        loading     = false,
        spinner     = 'div.spinner',
        buttons     = '.module__news-events #loadMore, .module__load-more #loadMore',
        offset      = 0,
        FORM        = '',
        department  = 'company-news',
        include_filter_department = true,
        exclude_posts_on_page = false, // useful for components rendering posts on same page, like geconnect
        target_url  = $('[data-module-ajax]').attr('data-url'),
        post_type   = $('[data-module-ajax]').attr('data-type'),
        template_style = 1, // 1 = news style, 2 = geconnect style w/ excerpt
        base_url    = target_url + '?',
        term_url    = '',
        pageNumber  = 2,
        postPerPage = 9,
        noLoad      = false,
        startUrl;

    if (!running) {
        startUrl = document.location.href;
    }

    $('.filter-checkbox').on('click touch', filter_article_handle_change);
    $('.filter__form').on('change', filter_article_handle_change);

    $(buttons).on('click', function(e) {
        e.preventDefault();

        if (loading) {
            return false;
        }

        if ( is_geconnect() ) {
            let $module = $(this).closest('.module__post-grid');

            postPerPage = 8;
            template_style = 2;
            exclude_posts_on_page = true;
            department = $module.attr('data-category');
        }

        filter_article_load_more();
    });

    function filter_article_handle_change(e)
    {
        e.preventDefault();

        $('.filter__form button.is-active').removeClass('is-active');
        $(this).addClass('is-active');

        if ( $(this).hasClass('btn--filter') ) { // fill out hidden field if it's button type to make serialize work accurately 
            $(this).parents('form').find('input[name="filter-department"]').val( $(this).val() )
        }

        setTimeout(function(){
            $(this).parents('div.filter').prop('disabled', true).addClass('is-disabled');
        }, 250);

        running = false;

        FORM = $('.filter__form').serialize();
        department = $(this).val();

        var value = 'filter-department=' + department + '&post-type=' + post_type;

        term_url = base_url + FORM;
        
        if ( $(this).hasClass('btn--filter') ) { // fill out hidden field if it's button type to make serialize work accurately 
            term_url += value;
        }

        noLoad = false;

        $(spinner).addClass('is-active');

        filter_article_posts();
    }

    function filter_article_load_more()
    {
        append_article_posts();
        $(spinner).addClass('is-active');
    }

    function filter_article_posts()
    {   
        $(buttons).removeClass('is-disabled');

        $("#postList").load(term_url + ' #postList', function(){

            setTimeout(function(){
                $('div.filter').prop('disabled', false).removeClass('is-disabled');
            }, 1000);

            $('html, body').animate({
                scrollTop: $('[data-module-ajax]').offset().top - 200
            }, 500);

            if (!running) {
                startUrl = document.location.href;
            }

            $(spinner).removeClass('is-active');

            console.log('filter_article_posts()');

            $(document).trigger('loadMorePosts:added'); 
        });
    }

    function append_article_posts()
    {
        $(buttons).removeClass('is-disabled');
        offset = $('.module__news-events-list .module__item, .module__post-grid[data-module-ajax] .module__item').length;
        var str = '';

        if (exclude_posts_on_page) {
            var exclude_ids = gather_post_ids();
            str += 'exclude-ids=' + exclude_ids.join(',') + '&';

            pageNumber = 1;
            offset = 0;
        }

        if (include_filter_department) {
            str += 'filter-department=' + department + '&';
        }

        str += 'post-type=' + post_type + '&postsPerPage=' + postPerPage + '&pageNumber=' + pageNumber + '&postOffset=' + offset + '&action=syn_ajax' + '&template-style=' + template_style;
        
        term_url = FORM + str;

        loading = true;

        $.ajax({
            type: "POST",
            dataType: "html",
            url: synAjax.ajaxurl,
            data: term_url,
            success: function(data) {
                var $data = $(data);

                if ($data.length) {
                    if (is_geconnect()) {
                        $('.module__post-grid[data-module-ajax] .module__container-wrap').append($data);
                    } else {
                        $('#postList').append($data);
                    }

                    if ($data.length < postPerPage) {
                        noLoad = true;

                        $(buttons).addClass('is-disabled');
                    }

                    $(document).trigger('loadMorePosts:added'); 
                } else {
                    noLoad = true;

                    $(buttons).addClass('is-disabled');
                }

                $(spinner).removeClass('is-active');
                pageNumber++;
                loading = false;
            },
            error: function(jqXHR, textStatus, errorThrown) {
                // console.log(jqXHR = " :: " + textStatus + " :: " + errorThrown);
                $loader.html(jqXHR = " :: " + textStatus + " :: " + errorThrown);
            }
        });

        return false;
    }

    function is_geconnect()
    {
        return window.location.pathname.indexOf('geconnect') > -1;
    }

    function gather_post_ids()
    {
        let exclude_ids = [];

        $('*[data-post-id]').each(function(){
            var id = $(this).attr('data-post-id');
            exclude_ids.push(id);
        });

        console.log(exclude_ids);
        return exclude_ids;
    }
})(jQuery);